var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(!_vm.hidePageTitle)?_c('PageTitle',{attrs:{"title":"Live Statuses","crumbs":[{href:'/home',title:'Home'},{href:'/live_status_of_branches',title:'Live Statuses'}]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }